import { Account } from './account';
import CallIntegrationType from './enums/callIntegrationType';
import type { CallDirection } from './externalCallLog';
import { Prospect } from './prospect';

export interface LogCall {
  taskTodoId: number | null;
  opportunityId: string | null;
  suggestionId: number | null;
  accountId: string;
  prospectId: string;
  telephone: string;
  callFeedback: CallFeedback;
  sentiment?: CallSentiment;
  note: string;
  id?: number;
  account?: Account;
  prospect?: Prospect;
  eventDatetime?: Date;
  owner?: string;
  stopSequence?: boolean | null;
  externalLog?: string | null;
  externalDirectLink?: string | null;
  externalRegistrationLink?: string | null;
  externalDuration?: number | null;
  integrationType?: CallIntegrationType;
  direction?: CallDirection | null;
  templateTitle?: string | null;
  externalCallId?: string | null;
  templateId?: number | null;
  externalFrom?: string | null;
  strategyName?: string | null;
  keepTaskPending?: boolean | null;
  keepTaskPendingNewActivityDate?: string | null;
  fromPhoneNumber?: string | null;
  subject?: string | null;
  transcript?: string | null;
  externalValues?: { [key: number]: string | null };
}

export enum CallFeedback {
  CONNECTED = 'Connected',
  NOT_ANSWERED = 'NotAnswered',
  VOICEMAIL = 'Voicemail',
  GATE_KEEPER = 'GateKeeper',
  WRONG_NUMBER = 'WrongNumber',
  BUSY = 'Busy',
}

export enum CallSentiment {
  NOT_INTERESTED = 'NotInterested',
  CALL_BACK = 'CallBack',
  MEETING_SCHEDULED = 'MeetingScheduled',
  NOT_RIGHT_CONTACT = 'NotRightContact',
  SEND_EMAIL = 'SendEmail',
  PERSONAL_NUMBER = 'PersonalNumber',
}

export const getCallFeedbackString = (status: CallFeedback | CallSentiment) => {
  switch (status) {
    case CallFeedback.CONNECTED:
    case CallSentiment.PERSONAL_NUMBER:
      return 'purple';
    case CallFeedback.NOT_ANSWERED:
    case CallSentiment.SEND_EMAIL:
      return 'yellow';
    case CallFeedback.VOICEMAIL:
    case CallSentiment.MEETING_SCHEDULED:
      return 'blue';
    case CallFeedback.GATE_KEEPER:
    case CallSentiment.CALL_BACK:
      return 'green';
    case CallFeedback.WRONG_NUMBER:
    case CallSentiment.NOT_RIGHT_CONTACT:
      return 'red';
    case CallFeedback.BUSY:
    case CallSentiment.NOT_INTERESTED:
      return 'pink';
    default:
      return '';
  }
};

export const getCallFeedbackText = (
  callStatus: CallFeedback | CallSentiment,
) => {
  switch (callStatus) {
    case CallFeedback.CONNECTED:
      return 'Connected';
    case CallFeedback.NOT_ANSWERED:
      return 'Not Answered';
    case CallFeedback.VOICEMAIL:
      return 'Voicemail';
    case CallFeedback.GATE_KEEPER:
      return 'Gatekeeper';
    case CallFeedback.WRONG_NUMBER:
      return 'Wrong Number';
    case CallFeedback.BUSY:
      return 'Busy';
    case CallSentiment.SEND_EMAIL:
      return 'Send Email';
    case CallSentiment.MEETING_SCHEDULED:
      return 'Meeting Scheduled';
    case CallSentiment.CALL_BACK:
      return 'Call Back';
    case CallSentiment.NOT_INTERESTED:
      return 'Not Interested';
    case CallSentiment.NOT_RIGHT_CONTACT:
      return 'Not Right Contact';
    case CallSentiment.PERSONAL_NUMBER:
      return 'Personal Number';
    default:
      return '';
  }
};

export enum QuickAction {
  CALL_BACK = 'CallBack',
  STOP_PROSPECT = 'StopProspect',
  NURTURE = 'Nurture',
  INACTIVE = 'Inactive',
  CALL_SCHEDULED = 'CallScheduled',
}
